<template>
  <a-modal width="75%"
           :title="title"
           :visible="innerVisible"
           @cancel="handleCancel"
           cancelText="关闭"
           :okButtonProps="{style:{display:'none'}}">
    <a-form layout="inline">
      <a-row :gutter="12">
        <a-col :md="6"
               :sm="12">
          <a-form-item label="分类编号">
            <a-input v-model="query.classNo"
                     placeholder="支持开始编号与结束编号查询"
                     allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="6"
               :sm="12">
          <a-form-item label="物探点号">
            <a-input v-model="query.geophysicalPointNumber"
                     placeholder="支持开始物探点与连接编号查询"
                     allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="8"
               :sm="12">
          <a-form-item>
            <a-button type="primary"
                      @click="loadData">查询</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary"
                      @click="exportHandle">导出</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-alert type="info"
             showIcon
             style="margin-bottom: 16px; margin-top: 16px">
      <template slot="message">
        <span>已选择</span>
        <a style="font-weight: 600;padding: 0 4px;">{{ selectedRowKeys.length }}</a>
        <span>项</span>
        <template v-if="selectedRowKeys.length>0">
          <a-divider type="vertical" />
          <a @click="handleClearSelection">清空选择</a>
          <a-divider type="vertical" />
          <a @click="exportHandle">导出</a>
          <a-divider type="vertical" />
          <a @click="handleIgnoreBatch">批量忽略</a>
          <a-divider type="vertical" />
          <a @click="handleProcessedBatch">标记处理</a>
        </template>
      </template>
    </a-alert>
    <a-table ref="table"
             rowKey="id"
             size="middle"
             bordered
             :columns="columns"
             :loading="loading"
             :dataSource="dataSource"
             :pagination="pagination"
             :rowSelection="{selectedRowKeys, onChange: handleTableSelectChange}"
             @change="pageChange">
      <span slot="status"
            slot-scope="text, record">
        <a-tag v-if="record.status === 1"
               color="#f50">未处理</a-tag>
        <a-tag v-if="record.status === 2">忽略</a-tag>
        <a-tag v-if="record.status === 3"
               color="green">已处理</a-tag>
      </span>
      <span slot="action"
            slot-scope="text, record">
        <a @click="handleIgnore([record.id])">
          <a-icon type="info" />忽略
        </a>
        <a-divider type="vertical" />
        <a @click="handleProcessed([record.id])">
          <a-icon type="check" />处理
        </a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>

// 高度封装的请求，请务必使用 superRequest.call(this,{}) 的方式调用
// eslint-disable-next-line no-unused-vars
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

function superRequest (options) {
  this.loading = !!options.loading
  options.promise
    .then(res => {
      if (res.success && typeof options.success === 'function') {
        options.success(res)
      } else {
        throw new Error(res.message)
      }
    })
    .catch(e => {
      this.$message.warning('查询数据检查失败：' + (e.message || e))
    })
    .finally(() => {
      this.loading = false
    })
}

export default {
  name: 'PipeLineDataCheck',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: '管线数据检查',
      loading: false,
      innerVisible: false,
      selectedRowKeys: [],
      dataSource: [],
      query: {
        classNo: '',
        geophysicalPointNumber: ''
      },
      columns: [
        {
          title: '开始分类编码',
          dataIndex: 'startClassNo'
        },
        {
          title: '结束分类编码',
          dataIndex: 'endClassNo'
        },
        {
          title: '物探点号',
          dataIndex: 'startGeophysicalPointNumber'
        },
        {
          title: '连接点号',
          dataIndex: 'endGeophysicalPointNumber'
        },
        {
          title: '处理状态',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '检查类型',
          dataIndex: 'checkType'
        },
        {
          title: '修复建议',
          dataIndex: 'fixMessage'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '删除时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
        },
        { title: '操作', align: 'center', dataIndex: 'action', width: 200, scopedSlots: { customRender: 'action' } }
      ],
      url: {
        // 回收站操作，get = 获取列表；put = 取回；delete = 彻底删除
        queryList: '/pipe-network/gis/pipe-line/data-check/page',
        batchIgnores: '/pipe-network/gis/pipe-line/data-check/status-ignores',
        batchProcessed: '/pipe-network/gis/pipe-line/data-check/status-processed'
      },
      exportDataUrl: 'pipe-network/gis/pipe-line/data-check/export',
      exportFileName: '数据检查.xlsx',
      uploadHeader: {
        Authorization: storage.get(ACCESS_TOKEN)
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.loadData()
        }
        this.innerVisible = val
      }
    },
    innerVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loadData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.query
      }
      this.$http
        .get(this.url.queryList, {
          params
        })
        .then(({ data }) => {
          this.pagination.total = data.total ? parseInt(data.total) : 0
          this.dataSource = data.list
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 导出
    exportHandle () {
      this.exportLoading = true
      const params = {
        responseType: 'arraybuffer',
        params: this.query,
        headers: this.uploadHeader
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios.get(url, params).then((res) => {
        const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
        const fileName = this.exportFileName || '导出数据.xlsx'
        const eLink = document.createElement('a')
        eLink.download = fileName
        eLink.style.display = 'none'
        eLink.href = URL.createObjectURL(blob)
        document.body.appendChild(eLink)
        eLink.click()
        URL.revokeObjectURL(eLink.href)
        document.body.removeChild(eLink)
        this.$message.success('导出完成')
        this.exportLoading = false
      }).catch(() => {
        this.exportLoading = false
      })
    },
    handleOk () {
      this.loadData()
      this.$emit('ok')
    },
    handleCancel () {
      this.innerVisible = false
    },
    // 忽略处理
    handleIgnore (userIds) {
      this.$confirm({
        title: '忽略处理',
        content: `您确定要忽略处理 ${userIds.length} 条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put(this.url.batchIgnores, [...userIds]).then(res => {
            if (res.code === 0) {
              this.handleOk()
              this.handleClearSelection()
              this.$message.success(`忽略处理 ${userIds.length} 条数据成功！`)
            }
          })
        }
      })
    },
    // 标记处理
    handleProcessed (userIds) {
      this.$confirm({
        title: '标记处理',
        content: (
          <div>
            <p>您确定要标记处理这 {userIds.length} 个数据吗？</p>
          </div>
        ),
        centered: true,
        onOk: () => {
          var that = this
          // eslint-disable-next-line no-unused-vars
          const params = {
            idList: userIds
          }
          this.$http.put(that.url.batchProcessed, [...userIds]).then(res => {

            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success(`标记处理 ${userIds.length} 条数据成功！`)
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    handleIgnoreBatch () {
      this.handleIgnore(this.selectedRowKeys)
    },
    handleProcessedBatch () {
      this.handleProcessed(this.selectedRowKeys)
    },
    handleClearSelection () {
      this.handleTableSelectChange([], [])
    },
    handleTableSelectChange (selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    }
  }
}
</script>

<style lang="less" scoped></style>
